module.exports = __webpack_public_path__ + "mg.svg?fba42999241fe114d86f32140ad674c8";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/mg.svg
// module id = 1237
// module chunks = 0